import React from "react";
import {
  Checkbox,
  Popper,
  Grow,
  Box,
  Paper,
  makeStyles,
  ClickAwayListener,
  MenuList,
  MenuItem,
  Typography,
  Divider
} from "@material-ui/core";
import clsx from "clsx";
import RequireSvg from "assets/svg/require.svg";

const style = (theme) => ({
  root: {
    borderRadius: theme.spacing(0.5),
    transition: theme.transitions.create("all", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shortest,
    }),
    margin: "-8px"
  },
  paper: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    borderRadius: "4px"
  },
  boxSubmenu: {
    "&::before": {
      content: '""',
      position: "absolute",
      width: "0",
      height: "0",
      top: "-14px",
      left: "13px",
      border: "8px solid",
      borderColor: "transparent transparent transparent",
      borderBottomColor: theme.palette.primary.main,
      zIndex: 999
    }
  },
  menuItem: {
    fontSize: "small",
    display: "block"
  },
  menuItemRequired: {
    flexFlow: "column",
    placeItems: "flex-start",
    color: "rgba(255, 255, 255, 0.33)"
  },
  divider: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    margin: "0px -16px 6px -16px"
  },
  dividerStyle2: {
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    margin: "0px 0px 6px 0px"
  },
  errorText: {
    color: "#FD646F",
    fontWeight: 700
  },
  selectAll: {
    '&.Mui-checked': {
      color: "#FDB022",
    }
  },
  selectOne: {
    '&.Mui-checked': {
      color: "#6AAF68",
    }
  }
});

const useStyles = makeStyles(style);

export default function SelectAllCheckboxComponent({
  isOpen,
  handleToggleOpen,
  anchorRef,
  handleListKeyDown,
  handleClose,
  actionItems,
  popperStyle,
  disabled,
  isSelectAll,
  selectedIdLength,
  totalFiltered,
}) {
  const classes = useStyles()

  return (
    <Box>
      <Popper
        open={isOpen}
        anchorEl={anchorRef.current}
        disablePortal={false}
        role={undefined}
        style={{ zIndex: 999, ...popperStyle }}
        transition
        placement="bottom-start"
      >
        {({ TransitionProps, placement }) => {
          return (
            <Grow
              {...TransitionProps}
            >
              <Box className={classes.boxSubmenu}>
                <Paper className={classes.paper}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={isOpen}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      {actionItems.map((item, index) => (
                        <MenuItem
                          key={index}
                          className={clsx(classes.menuItem, {
                            [classes.menuItemRequired]: item.required,
                            [classes.errorText]: item.errorText
                          })}
                          onClick={(e) => {
                            handleClose(e);
                            item.action();
                          }}
                          disabled={item.disabled}
                        >
                          {item.divider && <Divider className={classes.dividerStyle2} />}
                          {item.required ? (
                            <Divider className={classes.divider} />
                          ) : null}
                          {item.label}

                          {item.required ? (
                            <div style={{ display: "flex" }}>
                              <img src={RequireSvg} alt="required" />
                              <Typography
                                variant="caption"
                                style={{ color: "#FD646F", paddingLeft: "4px" }}
                              >
                                {item.requiredText}
                              </Typography>
                            </div>
                          ) : null}
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Box>
            </Grow>
          );
        }}
      </Popper>

      <Checkbox
        className={clsx(classes.root,{
          [classes.selectAll]: isSelectAll,
          [classes.selectOne]: selectedIdLength === totalFiltered && !isSelectAll,
        })}
        checked={((!isSelectAll && selectedIdLength === totalFiltered) || (isSelectAll && selectedIdLength === 0)) && totalFiltered > 0 }
        disabled={disabled}
        inputRef={anchorRef}
        onChange={(e) => {
          e.preventDefault();
          handleToggleOpen()
        }}
      />
      
    </Box>
  )
}